import { format } from "./format"

// sleep function using promise
export function sleep(time = 1000) {
  return new Promise(resolve => {
    setTimeout(resolve, time);
  });
}

export default sleep;

export async function sleepFail(time = 1000, error = 'Slept for {time}ms, then failed :(') {
  await sleep(time)
  throw new Error(format(error, { time }))
}
